/* eslint-disable */

const loggedReducer = (state=0, action) =>{
    switch(action.type){
        case "SIGN_IN":
            var tempState = {
                id : action.userData.id,
                loginEmail : action.userData.loginEmail,
                loginIc : action.userData.loginIc,
                role : action.userData.role,
                firstName : action.userData.firstName,
                lastName : action.userData.lastName,
                image : action.userData.image,
                states: action.userData.states
            }
            state = tempState
            return state
        case "ERROR":
            // console.log("CASE ERROR")
            // console.log(action)
            var tempState = {
                error : action.error
            }
            state = tempState
            return state
        case "SIGN_OUT":
            state = 0
            return state 
        default :
            return state
    }
  };

export default loggedReducer